import { jsx as _jsx } from "react/jsx-runtime";
function SvgArrowDRightIcon(props) {
    return (_jsx("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "M17.6337 12.7465C18.1222 12.3485 18.1221 11.6488 17.6335 11.2509L7.8164 3.25479C7.11249 2.68145 6 3.13951 6 4.00268V19.9978C6 20.8611 7.11268 21.3191 7.81655 20.7456L17.6337 12.7465Z", fill: "currentColor" }, void 0) }), void 0));
}
export default SvgArrowDRightIcon;
